<template>
	<v-navigation-drawer v-model="globalElevatorOpen" stateless absolute width="48" style="z-index: 2; overflow-y: hidden;  ">
	<v-card flat>
	<v-icon  
		style="position: relative; top: 75px; left: 10px;  " 
		@click="menuClickHandler"
		class="pb-3 pt-1 grey--text text--darken-2 text-xs-center">
		menu
	</v-icon>

	<v-list class="globalElevator" >
		<v-divider></v-divider>
		<v-list-tile 
			v-for="(item, index) in items" 
			:key="item" avatar 
			@click="clickHandler(item)"
			v-bind:class="{ selected: currentFloor == item}">
			<v-list-tile-content>
				<v-list-tile-title align-center v-text="item"></v-list-tile-title>
			</v-list-tile-content>			
		</v-list-tile>
	</v-list>
	</v-card>
	</v-navigation-drawer>

</template>

<script>
import { mapState, mapMutations } from 'vuex'

let ElevatorControl = {

	data() {
		return {
			drawer: true,
			selected : "",
				floors: [{ text : 'Floor B', value: 'B' },
						{ text : 'Floor 1', value: '1' },
						{ text : 'Floor 2', value: '2' },
						{ text : 'Floor 3', value: '3' },
						{ text : 'Floor 4', value: '4' },
						{ text : 'Floor 5', value: '5' },
						{ text : 'Floor 6', value: '6' },
						{ text : 'Floor 7', value: '7' },
						{ text : 'Floor 8', value: '8' },
						{ text : 'Floor 9', value: '9' },
						{ text : 'Floor 10', value: '10' },
						{ text : 'Floor 11', value: '11' },
						{ text : 'Floor 12', value: '12' }],
		}
	},
	components: {  },

	computed: {
		...mapState({
						building: state => state.space.selectedBuilding,
						currentFloor: state => state.ui.currentFloor,
						mainSidebarOpen: state => state.ui.mainSidebarOpen,
	 	}),

	 	globalElevatorOpen: {
	        get () {
	          return this.$store.state.ui.globalElevatorOpen
	        },
	        set () {
	            // Do Nothing
	        }
	    },
	 	
	  	items: function () {
	  		//console.log(this.building.floors)
	  		return this.building && this.building.floors || this.floors.map((item) => item.value)
	  	}
	},

	methods: {
		...mapMutations(['setCurrentFloor', 'updateGlobalElevator', 'updateMainSidebar']),

		clickHandler: function (floornumber) {
			this.setCurrentFloor(floornumber)
			this.updateGlobalElevator(false)
		},

		menuClickHandler: function () {
			this.updateMainSidebar(true)
		},
	}, 

}

export default ElevatorControl

</script>

<style>

.globalElevator {
	margin-top:58px;
	height: 100%;	
	background: transparent !important;
}

.globalElevator .v-list__tile {
	height: 40px !important;
	font-size: 14px;
}

.selected {
	background-color: #a2a2a2;;
}



</style>




// WEBPACK FOOTER //
// src/components/GlobalElevatorControl.vue